import { render, staticRenderFns } from "./regainEditDialog.vue?vue&type=template&id=1ffbf911&scoped=true&"
import script from "./regainEditDialog.vue?vue&type=script&lang=js&"
export * from "./regainEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./regainEditDialog.vue?vue&type=style&index=0&id=1ffbf911&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffbf911",
  null
  
)

export default component.exports